/* eslint-disable no-nested-ternary */
/* eslint-disable react/no-danger */
/* eslint-disable no-restricted-globals */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable @next/next/no-img-element */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable @next/next/no-html-link-for-pages */
import { format } from 'date-fns';
import { Check, ChevronsUpDown, Loader2, Share, X } from 'lucide-react';
import { useRouter } from 'next/router';
import { Dispatch, SetStateAction, useEffect, useRef, useState } from 'react';
import { DateRange } from 'react-day-picker';
import { isMobile } from 'react-device-detect';
import { RiFolderUploadLine } from "react-icons/ri";
import { useDispatch, useSelector } from 'react-redux';
import ConversationInsights from '@/pages/conversation-insights';
import { Button } from '../../components/ui/button';
import { DatePickerWithRange } from '../../components/ui/date-picker';
import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "../../components/ui/dropdown";
import withAuthenticator from '../../hoc/withAuthenticator/withAuthenticator';
import useDeviceDimension from '../../hooks/useDeviceDimension';
import useSnackbar from '../../hooks/useSnackbar';
import ChromePerfIcon from '../../public/icons/chrome-perf-ss.svg';
import InfoIcon from '../../public/icons/fluent_info-24-regular.svg';
import CrossIcon from '../../public/icons/thin-cross.svg';
import OrganisationService from '../../services/organisation/organisation.service';
import UserService from '../../services/user/user.service';
import { RootState } from '../../store/reducers';
import { TOGGLE_CALLQREPORT_MODAL } from '../../store/types';
import { ROUTES } from '../../utils/constants';
import styles from './common.module.css';
import Loader from '../../components/loader/loader.component';
import { insightsHubTabSelected, shareButtonClicked, threadListItemClicked } from '../../lib/ga/metabase.events';
import QueryEngine from '../../components/query-engine/query-engine';

const MetabaseDashboard: React.FC = () => {
  const { metabaseDashboards, user, realtimeWidget, features } = useSelector(
    (state: RootState) => state.common,
  );

  const isZipteamsUser = user?.email?.includes("zipteams@") || user?.email?.includes("@zipteams");

  const showConversationInsightsinTab =  isZipteamsUser && !user?.organisation?.feature_flags?.show_conv_insights_new && user?.organisation?.feature_flags?.show_conv_insights_tabbed;

  const dispatch = useDispatch();
  const router = useRouter();
  const { query } = router;
  // const [isAvailable, setIsAvailable] = useState(Boolean(availability));

  const isMobileWidth = useDeviceDimension();

  const [selectedDashboard, setSelectedDashboard] = useState('');
  const [selectedDashboardName, setSelectedDashboardName] = useState<string>('');
  const [showChromeExtensionModal, setShowChromeExtensionModal] = useState<boolean>(false); 
  const [visibleDashboards, setVisibleDashboards] = useState<{[key:string]: any}[]>([])
  const [featuresObj, setFeaturesObj] = useState<{[key:string]: any}>();
  const [insightsData, setInsightsData] = useState<{[key:string]: any}[]>([]); 
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const { isAdmin, isSuperAdmin, isDataAdmin, selectedWorkspace, isManager} = useSelector((state: RootState) => state.common);
  const isFetching = useRef<boolean>(false);

  const sleepTimeout = useRef<any>();


  const handleSelectDashboard = id => {
    const filteredDashBoard =
      visibleDashboards.length &&
      visibleDashboards.find(item => item?.dashboard_id === id);
    if (filteredDashBoard?.dashboard_name === 'Insights Hub') insightsHubTabSelected();
    if (!filteredDashBoard) return;
    router.push(`/reports?tab=${filteredDashBoard?.dashboard_name}${filteredDashBoard?.dashboard_name === 'Insights Hub' ? `&tid=${insightsData?.[0]?.id}` : ''}`)
  };

  const chromeExtensionModalIgnoreClickHandler = () => {
    setShowChromeExtensionModal(false);
    localStorage.setItem('availability_toggle', JSON.stringify({ count: 2 }));
  };

  // const toggleInstantMeetingAvailability = async () => {
  //   const audio = new Audio('/assets/sweet_text.ogg');
  //   audio.muted = true;
  //   audio.play();
  //   try {
  //     const realtime_meeting_availaibility = !isAvailable;
  //     const userData: any =
  //       localStorage && JSON.parse(localStorage.getItem('user_data'));
  //       let count = JSON.parse(localStorage.getItem('availability_toggle'))?.count||0;
  //       if(realtime_meeting_availaibility){
  //         localStorage.setItem(
  //           'availability_toggle',
  //           JSON.stringify({count:++count}),
  //         );
          
  //       }
  //     await UserService.update(userData?.id, {
  //       meta: { realtime_meeting_availaibility },
  //     });
  //     setIsAvailable(realtime_meeting_availaibility);
  //     dispatch({
  //       type: REALTIME_WIDGET_AVAILABILITY,
  //       payload: {
  //         availability: realtime_meeting_availaibility,
  //         userInteracted: true
  //       },
  //     });
  //   } catch (err) {
  //     dispatch({
  //       type: SHOW_SNACKBAR,
  //       payload: {
  //         type: 'error',
  //         message: 'Failed to toggle your availability. Please try again.',
  //       },
  //     });
  //   }
  // };

  const getUserProfileCookies = async () => {
    await UserService.getUserProfileCookies();
  };

  const isDashboardVisible = (itm) => {
    const flags = itm.feature_flags;
    if (flags?.length) {
      let counter = 0;
      flags.forEach(flag => {
        if (featuresObj && flag in featuresObj && !featuresObj?.[flag]) {
          counter+=1;
        }
      });
      return counter === 0;
    }
    return true;
  };

  const getInsightsHubDataForWp = async () => {
    try {
      isFetching.current = true;
      if (query.tab === 'Insights Hub') setIsLoading(true);
      const res = await OrganisationService.getReportsInsightsForWorkspace(selectedWorkspace?.[0]?.id);
      const insights = res?.data?.data;
      setInsightsData(insights);
      return insights ;
    } catch (err) {
      console.log(err);
      return false;
    } finally {
      isFetching.current = false;
      if (query.tab === 'Insights Hub') setIsLoading(false);
    }
  }

  const showLoader = async () => {
    if (query.tab === 'Insights Hub' || query.tab === 'Query Engine') {
      setIsLoading(false);
      clearTimeout(sleepTimeout.current);
      return;
    };
    setIsLoading(true);
    if (sleepTimeout.current) {
      clearTimeout(sleepTimeout.current);
    }
    sleepTimeout.current = setTimeout(() => {
      setIsLoading(false);
    }, 5000)
  }

  const initMetabaseDashboard = async () => {
    if (metabaseDashboards && metabaseDashboards?.length) {
      const visibleDashboard = []
      metabaseDashboards.forEach((itm) => {
        const res = isDashboardVisible(itm);
        if (res) {
          visibleDashboard.push(itm);
        }
      });
      const res = insightsData
      if (insightsData?.length) {
        const hasItem = visibleDashboard.filter(itm => itm.dashboard_id === 'insights_hub');
        if (!hasItem?.length && (isAdmin || isSuperAdmin)) {
          visibleDashboard.unshift({
            dashboard_name: "Insights Hub",
            dashboard_id: "insights_hub",
            dashboard_url: "insights_hub",
          });
        }
      }

      if(showConversationInsightsinTab){
        visibleDashboard.unshift({
          dashboard_name: "Overview",
          dashboard_id: "overview",
          dashboard_url: "overview",
        });
      }
      
      const updatedVisibleDashboard = visibleDashboard?.filter(itm => itm.dashboard_id !== 'query_engine');
      setVisibleDashboards(updatedVisibleDashboard || []);

      if (visibleDashboard?.length) {
        let dashboard = null;
        if (query?.tab) {
          dashboard = visibleDashboard.find(itm => itm.dashboard_name === query?.tab);
        }
        if (!dashboard) {
          dashboard = visibleDashboard?.[0]
        }
        if (
          dashboard?.manager_urls && 
          Object.keys(dashboard?.manager_urls)?.length && 
          dashboard?.manager_urls?.[user.email]
        ) {
          setSelectedDashboard(dashboard?.manager_urls?.[user.email]);
          setSelectedDashboardName(dashboard?.dashboard_name)
        } else {
          setSelectedDashboard(dashboard?.dashboard_url);
          setSelectedDashboardName(dashboard?.dashboard_name)
        }
        if (!query?.tab) {
          router.replace(`/reports?tab=${dashboard?.dashboard_name}${dashboard?.dashboard_name === 'Insights Hub' && res?.length ? `&tid=${res?.[0]?.id}` : ''}`)
          return;
        }        
        showLoader();
      }
    }
  }

  const getInsightsHubData = async () => {
    await getInsightsHubDataForWp();
  }

  useEffect(() => {
    if (
      JSON.parse(localStorage.getItem('availability_toggle'))?.count === 1 &&
      realtimeWidget?.availability
    ) {
      setShowChromeExtensionModal(true);
    }
  }, [realtimeWidget?.availability]);

  useEffect(() => {
    if (features?.length) {
      const featureObj = {};
      features.forEach(itm => { 
        featureObj[itm.feature] = itm.enabled
      }); 
      setFeaturesObj(featureObj);
    }
  }, [features])

  useEffect(() => {
    initMetabaseDashboard()
  }, [metabaseDashboards, insightsData, featuresObj, query?.tab])

  useEffect(() => {
    // No need to add isDataAdmin since dataAdmin is an Admin
    if (selectedWorkspace?.length && (isAdmin || isSuperAdmin )) {
      getInsightsHubData();
    }
  }, [selectedWorkspace])

  useEffect(() => {
    getUserProfileCookies();
  }, []);

  useEffect(()=>{
    if (!visibleDashboards?.length) return;

    const targetDashboard = visibleDashboards[0].dashboard_name;
    const tab = query?.tab;
  
    const hasPermission = {
      'Query Engine': isAdmin || isSuperAdmin,
      'Insights Hub': isAdmin || isSuperAdmin || isDataAdmin,
    };
  
    if (typeof tab === 'string' && tab in hasPermission && !hasPermission[tab]) {
      router.replace(`/reports?tab=${targetDashboard}`);
    }

  },[query, visibleDashboards])

  return (
    <div className="h-full w-full flex flex-col">
      {!isMobile && !isMobileWidth && showChromeExtensionModal && (
        <div
          className={`${styles['tooltip']} fixed top-12 z-20 rounded mx-2 right-4 bg-primary text-white text-base leading-5`}
        >
          <div className={styles['tooltip-arrow']} />

          <div
            className="relative px-3 py-2 text-sm"
            style={{ width: '700px' }}
          >
            <div>
              <div className="font-bold">
                Please complete the below steps to ensure you get instant
                meeting alerts on your Chrome browser
              </div>
              <div className="mt-4 font-normal ">
                <div className="pl-1">
                  1. Install Zipteams Chrome Extension to get instant meeting
                  alerts across on any tab that you working on Chrome.{' '}
                  <a
                    href="https://chrome.google.com/webstore/search/zipteams"
                    target="_blank"
                    rel="noreferrer"
                    className="font-bold underline"
                  >
                    Install Now.
                  </a>
                </div>
                <div className="mt-3 pl-1 pb-1">
                  2. Add{' '}
                  <a
                    className="font-bold"
                    href="https://app.zipteams.com"
                    target="_blank"
                    rel="noreferrer"
                  >
                    app.zipteams.com
                  </a>{' '}
                  to always active in Chrome &gt; Settings &gt; Performance as
                  shown below.{' '}
                  <a
                    className="font-bold underline"
                    href="https://blog.google/products/chrome/new-chrome-features-to-save-battery-and-make-browsing-smoother/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Click here
                  </a>{' '}
                  to know more.
                </div>
                <ChromePerfIcon />
              </div>
            </div>
            <button
              type="button"
              className="bg-transparent font-bold text-xs leading-3.5 flex justify-center items-center p-1 cursor-pointer rounded-full absolute top-1 right-1"
              onClick={() => {
                chromeExtensionModalIgnoreClickHandler();
              }}
            >
              <CrossIcon className="w-3 h-3" />
            </button>
          </div>
        </div>
      )}
      <div className={`${styles['horizontal-menu']} relative w-full whitespace-nowrap overflow-x-auto flex flex-col max-w-[200px] min-w-full h-auto min-h-[76px]`}>
        <div className="flex w-full">
          {visibleDashboards?.length &&
            visibleDashboards.map(item => (
              <button   
                className={`${
                  selectedDashboardName === item?.dashboard_name &&
                  styles['text-underline']
                } pb-4 pt-4`}
                key={item?.dashboard_id}
                type="button"
                onClick={() => handleSelectDashboard(item?.dashboard_id)}
              >
                <div
                  className={`${
                    selectedDashboardName === item?.dashboard_name
                      ? 'font-semibold text-base lg:text-xl'
                      : 'font-normal  lg:text-lg'
                  } my-2 px-6 text-metabase-tab`}
                >
                  {item?.dashboard_name}
                </div>
              </button>
            ))}
        </div>
      </div>
      <div className='flex items-center justify-between pb-3 px-4'>
        <div className='text-[#8f8f8f] text-sm font-semibold flex items-center gap-1'>
          <InfoIcon className="w-5 h-5" />
          Dashboards reflect data with a 10-15 minute delay.
        </div>
        {(selectedDashboardName === 'Call Quality Deep Dive' || selectedDashboardName === 'Call Quality') && (isAdmin || isManager) &&  (
          <button
            type="button"
            className='text-sm font-bold text-secondary flex items-center justify-center'
            onClick={() => dispatch({ type: TOGGLE_CALLQREPORT_MODAL, payload: true })}
          >
            <RiFolderUploadLine className='w-5 h-4.5 text-secondary mr-1'/>
            Export as CSV
          </button> 
        )}
      </div>
      <div className="relative w-full overflow-y-auto h-full">
        {isLoading ? (
          <div className='w-full h-full bg-white'>
            <Loader visible={isLoading} />
          </div>
        ) : (
          <>
            {selectedDashboard === 'overview' ? <ConversationInsights /> 
             : selectedDashboard === 'insights_hub' ? (
              <InsightsHub insights={insightsData} selectedThreadId={query?.tid || insightsData?.[0]?.id} />
            ) : selectedDashboard === 'query_engine' ? (
              <QueryEngine />
            ) : (
              <iframe
                src={selectedDashboard}
                className="h-full w-full"
                title="metabase-dashboard"
              />
            )}
          </> 
        )}
      </div>
    </div>
  );
};

type ExportToXLSXModalProps = {
  open: boolean;
  setOpen: Dispatch<SetStateAction<boolean>>
}
export const ExportToXLSXModal = (props: ExportToXLSXModalProps) => {
  const { showSnackbar } = useSnackbar();
  const { selectedWorkspace, workspaces, isSuperAdmin, user } = useSelector((state: RootState) => state.common);
  const { open, setOpen } = props;
  const [date, setDate] = useState<DateRange | undefined>({
    from: undefined,
    to: undefined,
  });
  const [isExporting, setIsExporting] = useState<boolean>(false);
  const [selectedWorkspaces, setSelectedWorkspaces] = useState<number[]>([]);

  const handleExport = async () => {
    try {
      setIsExporting(true);
      const payload = {
        started_at: format(date?.from || new Date(), 'yyyy-MM-dd'),
        ...({ ended_at: date?.to ? format(date?.to || new Date(), 'yyyy-MM-dd') : format(date?.from || new Date(), 'yyyy-MM-dd') }),
        ...(selectedWorkspaces?.length ? {workspace_ids: selectedWorkspaces} : {}),
        user_id: user?.id,
        is_superadmin: isSuperAdmin
      }
      const response = await OrganisationService.exportCallQualityReport(selectedWorkspace?.[0]?.id, payload);
      const downloadLink = response?.data?.data?.result?.download_link;
      const fileName = response?.data?.data?.result?.filename;
      if (downloadLink && fileName) {
        let downloadElm = document.createElement('a');
        downloadElm.href = downloadLink;
        downloadElm.download = fileName;
        document.body.appendChild(downloadElm);
        downloadElm.click();
        document.body.removeChild(downloadElm);
        downloadElm = null;
      }

      setDate({
        from: undefined,
        to: undefined,
      });
      setSelectedWorkspaces([]);
      if (fileName) {
        setTimeout(async () => {
          await OrganisationService.deleteCallQualityReport(selectedWorkspace?.[0]?.id, fileName); 
        }, 2000);
      }
    } catch (error) {
      console.log(error);
      showSnackbar({
        type: 'error',
        message: 'Error exporting the file, Please try again'
      });
    } finally {
      setIsExporting(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent 
        className="max-w-[90%] min-h-[230px] md:max-w-[450px] pt-6 pb-8 px-[50px] bg-white gap-0"
        onInteractOutside={(e) => e.preventDefault()}
      >
        <DialogHeader className="space-y-0 mx-auto">
          <DialogTitle className="text-xl font-bold leading-7 text-center">Export Report</DialogTitle>
        </DialogHeader>
        <div className='my-6 w-full flex flex-col gap-3'>
          <div className='flex flex-col gap-1.5'>
            <div className='font-semibold leading-5 text-sm'>Conversation Date</div>
            <DatePickerWithRange selectedDate={date} setSelectedDate={setDate} />
          </div>
          {isSuperAdmin && selectedWorkspace?.[0]?.name === 'Default' && (
            <div className='flex flex-col gap-1.5'>
              <div className='font-semibold leading-5 text-sm'>Select Workspace</div>
              <MultiSelectDropdownWithBadges workspaces={workspaces} setSelectedWorkspaces={setSelectedWorkspaces} />
            </div>
          )}
          <span className='text-xxs'>Note: Exporting report is available for maximum 31 days at a time</span>
        </div>
        <DialogFooter className='mx-auto flex-col sm:flex-col items-center sm:items-center'>
          <Button
            variant='secondary'
            className='w-[200px] flex gap-3'
            disabled={!date?.from || isExporting}
            onClick={handleExport}
          >
            {isExporting ? <Loader2 className='w-5 h-5 animate-spin' /> : ''}
            {isExporting ? 'Exporting...' : 'Export'}
          </Button>
          {isExporting && (
            <div className="text-xs mt-2">Export is in process, it may take few minutes so you can close the popup and check again in some time.</div>
          )}
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

type MultiSelectDropdownWithBadgesProps = {
  workspaces: {[key:string]: any}[];
  setSelectedWorkspaces:  Dispatch<SetStateAction<number[]>>;
}
const MultiSelectDropdownWithBadges = ({ workspaces, setSelectedWorkspaces }: MultiSelectDropdownWithBadgesProps) => {
  const [checkedItems, setCheckedItems] = useState<{ [key: string]: boolean }>({});
  const [open, setOpen] = useState(false);
  const divRef = useRef<HTMLDivElement | null>(null);
  const divRef1 = useRef<HTMLDivElement | null>(null);

  const handleCheckedChange = (optionId: string) => (checked: boolean) => {
    setCheckedItems(prev => ({ ...prev, [optionId]: checked }))
  }

  const removeItem = (optionId: string) => {
    setCheckedItems(prev => {
      const newCheckedItems = { ...prev }
      delete newCheckedItems[optionId]
      return newCheckedItems
    })
  }

  const handleSelectAll = (checked: boolean) => {
    const newCheckedItems = workspaces.reduce((acc, option) => {
      acc[option.id] = checked
      return acc
    }, {} as { [key: string]: boolean })
    setCheckedItems(newCheckedItems)
  }

  const handleOpenChange = (val) => {
    if (val && ((divRef?.current && divRef.current.contains(event.target as any)) || (divRef1?.current && divRef1.current.contains(event.target as any)))) {
      return
    }
    setOpen(val);
  }

  useEffect(() => {
    const keys = checkedItems && Object.keys(checkedItems);
    if (!open && keys?.length) {
      const ids = keys.filter(key => checkedItems[key]).map(key => Number(key));
      setSelectedWorkspaces(ids);
    }
  }, [open, checkedItems])

  function CheckboxItem({ option, checked, onCheckChange }: { option: {[key:string]: any}, checked: boolean, onCheckChange?: (pChecked: boolean) => void }) {
    return (
      <DropdownMenuItem
        onSelect={(e) => {
          e.preventDefault();
          e.stopPropagation();
        }}
        className="flex items-center space-x-2 px-3 py-2"
      >
        <div className="flex items-center space-x-2 flex-grow cursor-pointer">
          <input
            type='checkbox'
            id={option.id}
            checked={checked}
            className="outline-secondary border border-audio-timeline text-secondary rounded-sm appearance-none cursor-pointer"
            onChange={() => {
              onCheckChange(!checked)
            }}
          />
          <label htmlFor={option.id} className="flex-grow cursor-pointer">
            {option.name}
          </label>
        </div>
        {checked && <Check className="h-4 w-4 text-primary" />}
      </DropdownMenuItem>
    )
  }

  const selectedOptions = workspaces.filter(option => checkedItems[option.id])
  const allSelected = selectedOptions.length === workspaces.length

  return (
    <DropdownMenu open={open} onOpenChange={handleOpenChange}>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" className="w-full min-h-[2.5rem] h-auto justify-between">
          {selectedOptions.length === 0 ? (
            <div className="flex flex-wrap gap-1 items-center" ref={divRef} onClick={(e) => e.stopPropagation()}>
              <span className="font-normal text-muted-foreground">Select options</span>
            </div>
          ) : (
            <div className="flex flex-wrap gap-1 items-center max-h-[150px] overflow-y-auto" ref={divRef1} onClick={(e) => e.stopPropagation()}>
              {allSelected ? (
                <div className="mr-1 mb-1 bg-[#E1EBEF] rounded-lg p-2 pr-4 relative font-normal">
                  All
                  <button
                    type='button'
                    className="absolute top-0.5 right-0.5 rounded-full"
                    onClick={(e) => {
                      handleSelectAll(false)
                    }}
                    aria-label="Remove all selected options"
                  >
                    <X className="h-3 w-3" />
                  </button>
                </div>
              ) : (
                selectedOptions.map(option => (
                  <div key={option.id} className="mr-1 mb-1 bg-[#E1EBEF] rounded-lg p-2 pr-4 relative font-normal">
                    {option.name}
                    <button
                      type='button'
                      className="absolute top-0.5 right-0.5 rounded-full"
                      onClick={(e) => {
                        removeItem(option.id);
                      }}
                      aria-label={`Remove ${option.label}`}
                    >
                      <X className="h-3 w-3" />
                    </button>
                  </div>
                ))
              )}
            </div>
          )}
          <ChevronsUpDown className="h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent className="w-[350px] bg-white py-2 h-[200px] max-h-[200px] overflow-y-auto">
        <div className=''>
          <CheckboxItem
            option={{ id: 'select-all', name: 'Select All' }}
            checked={allSelected}
            onCheckChange={handleSelectAll}
          />
          {workspaces.map((option) => (
            <CheckboxItem
              key={option.id}
              option={option}
              checked={!!checkedItems[option.id]}
              onCheckChange={handleCheckedChange(option.id)}
            />
          ))}
        </div>
      </DropdownMenuContent>
    </DropdownMenu>
  )
}

type InsightsHubProps = {
  insights: { [key:string]: any }[];
  selectedThreadId: number;
};
const InsightsHub = ({ insights, selectedThreadId } : InsightsHubProps) => {
  const [seletedThread, setSelectedThread] = useState<{[key:string]: any}>();
  const { replace, query } = useRouter();
  const { showSnackbar } = useSnackbar();

  const handleThreadClick = (id: number) => {
    threadListItemClicked()
    const thread = insights?.length && insights?.filter(insight => insight.id === id);
    if (!thread?.length) {
      setSelectedThread(insights?.[0]);
    } else {
      setSelectedThread(thread?.[0]);
    }
    replace(`/reports?tab=Insights Hub&tid=${!thread?.length ? insights?.[0]?.id : id}`)
  };

  const handleShareButtonClick = () => {
    shareButtonClicked()
    const url = window.location.href;
    navigator.clipboard.writeText(url);
    showSnackbar({
      type: 'success',
      message: 'Copied to clipboard',
    });
  };

  useEffect(() => {
    if (insights?.length && selectedThreadId && query?.tid) { 
      handleThreadClick(Number(selectedThreadId))
    }
  }, [selectedThreadId]);

  return (
    <div className='w-full h-full p-6'>
      <div className='border border-[#14262F]/10 rounded-xl h-full py-4 flex gap-2.5'>
        <div className='w-[30%] max-w-[260px] flex flex-col gap-1'>
          {insights.map(itm => (
            <div 
              key={itm?.id} 
              className={`flex gap-3 font-semibold items-center leading-5 h-[40px] max-h-[40px] cursor-pointer ${
                seletedThread?.id === itm?.id ? 'text-secondary' : 'text-primary-dark'
              }`}
              onClick={() => handleThreadClick(itm?.id)}
            >
              <div className={`h-6 w-1 rounded-tr rounded-br ${seletedThread?.id === itm?.id ? 'bg-secondary' : 'bg-transparent'}`} />
              {itm?.name}
            </div>
          ))}
        </div>
        <div className='w-full flex flex-col'>
          <div className='flex justify-between px-4 items-center'>
            <div className='text-xl font-bold text-secondary'>
              {seletedThread?.name}
            </div>
            <Button
              variant='outline'
              className='border border-[#D7D7D7] rounded-3xl px-2 text-[#878787] text-base leading-5 flex items-center gap-2.5 font-normal'
              onClick={handleShareButtonClick}
            >
              <Share className='w-4 h-4'/>
              Share
            </Button>
          </div>
          <div className='h-0 w-auto border border-[#D7D7D7] mt-4 mb-6 mx-4'/>
          <div dangerouslySetInnerHTML={{ __html: seletedThread?.content }} className='[&_h1]:font-bold [&_h2]:font-bold [&_h3]:font-bold [&_h4]:font-bold [&_h5]:font-bold [&_h6]:font-bold [&_ol]:list-decimal [&_ol]:ps-[40px] [&_ul]:list-disc [&_ul]:ps-[40px] overflow-y-auto pl-4'/>
        </div>
      </div>
    </div>
  );
}

export default withAuthenticator(MetabaseDashboard, {
  redirectPath: `/auth/${ROUTES.AUTH_TYPES.LOGIN}`,
  onlyAdmin: true,
});
